import { render, staticRenderFns } from "./DetailDialog.vue?vue&type=template&id=5dc1aaa5&scoped=true"
import script from "./DetailDialog.vue?vue&type=script&lang=js"
export * from "./DetailDialog.vue?vue&type=script&lang=js"
import style0 from "./DetailDialog.vue?vue&type=style&index=0&id=5dc1aaa5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dc1aaa5",
  null
  
)

export default component.exports